import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-lock',
  templateUrl: './lock.component.html',
  styleUrls: ['./lock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockComponent implements OnInit, OnChanges {
  public lockStatus: boolean;

  @Input() isLock: boolean;
  @Output() onLockChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  public ngOnInit(): void {
    this.lockStatus = this.isLock;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isLock) {
      this.lockStatus = changes.isLock.currentValue;
    }
  }

  public changeLockStatus(): void {
    this.lockStatus = !this.lockStatus;
    this.onLockChanged.emit(this.lockStatus);
  }
}
